module.exports = __webpack_public_path__ + "static/media/chanel-mademoiselle-big.278ac26d.png";